<div class="modal-header">
    <h4 class="modal-title fw-bold" id="depositHeader" jhiTranslate="inventoryManagerApp.lot.deposit.title">Deposit</h4>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true"
            (click)="clear()">
    </button>
</div>
<div class="modal-body">
    <div class="mb-3 d-flex align-items-center">
        <span jhiTranslate="inventoryManagerApp.lot.deposit.note" [translateValues]="{ param: totalSelectedLots }"></span><br></div>
    <div class="border-bottom mb-3"></div>
    <form name="form" #f="ngForm">
        <table class="table table-striped table-bordered table-curved">
            <thead>
            <tr>
                <th><span jhiTranslate="inventoryManagerApp.lot.deposit.column.units">Units</span></th>
                <th><span jhiTranslate="inventoryManagerApp.lot.deposit.column.selected.lots">#Selected Lots</span></th>
                <th><span jhiTranslate="inventoryManagerApp.lot.deposit.column.amount">Amount</span></th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let deposit of lotsDeposits">
                <td>{{deposit.unit}}</td>
                <td style="text-align: center;">{{deposit.count}}</td>
                <td>
                    <input type="number" class="form-control" name="depositAmount-{{deposit.unit}}" id="depositAmount-{{deposit.unit}}"
                           [(ngModel)]="deposit.amount" jhi-customMinGreaterThanValidator min="0" #depositAmount="ngModel"
                           [ngClass]="{ 'is-invalid': f.submitted && depositAmount.invalid }"
                           [required]="true"/></td>
            </tr>
            </tbody>
        </table>
        <div class="border-top mb-3"></div>
        <div class="mb-3">
            <div class="col" style="padding-left: 0px;">
                <label class="fw-bold" for="depositNotes" jhiTranslate="inventoryManagerApp.lot.adjustment.notes">Notes</label>
            </div>
            <div class="col" style="padding-left: 0px;padding-right: 0px;">
                <textarea class="form-control" rows="3" name="depositNotes" id="depositNotes" [(ngModel)]="notes" jhi-forbiddenCharactersValidator #depositNotes="ngModel" [maxlength]="255" data-test="depositNotes"></textarea>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="form-check">
                    <input type="checkbox" class="form-check-input" [(ngModel)]="confirmDepositTransactions.selected" name="depositAvailable" id="depositAvailable" data-test="confirmDepositTransactionCheckbox">
                    <label class="form-check-label" for="depositAvailable" jhiTranslate="inventoryManagerApp.lot.deposit.confirm.message">Confirm transactions on saving</label>
                </div>
            </div>

        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="clear()" data-test="cancelDepositTransactionButton">
        <span class="fa fa-ban"></span>&nbsp;<span jhiTranslate="entity.action.cancel">Cancel</span>
    </button>
    <button type="button" class="btn btn-primary" [disabled]="f.form.invalid" (click)="save()" data-test="saveDepositTransactionButton">
        <span class="fa fa-save"></span>&nbsp;<span jhiTranslate="entity.action.save">Save</span>
    </button>
</div>
